/* ==========================================================
   Options Hero Slider
   Premium Hero Slider for Dawn v15.5.0
   Uses Swiper 11
========================================================== */

(() => {
  'use strict';

  const instances = new Map();

  function initHeroSlider(section) {
    if (!section) return;

    const slider = section.querySelector('.options-hero-slider');

    if (!slider) return;

    // Prevent duplicate initialization
    if (instances.has(section.id)) {
      instances.get(section.id).destroy(true, true);
      instances.delete(section.id);
    }

    const swiperElement = slider.querySelector('.swiper');

    if (!swiperElement) return;

    const autoplayEnabled = slider.dataset.autoplay === 'true';
    const loop = slider.dataset.loop === 'true';
    const effect = slider.dataset.effect || 'slide';
    const speed = Number(slider.dataset.transition) || 800;
    const delay = (Number(slider.dataset.speed) || 5) * 1000;

    const pagination = slider.querySelector('.swiper-pagination');
    const nextButton = slider.querySelector('.options-hero-slider__arrow--next');
    const prevButton = slider.querySelector('.options-hero-slider__arrow--prev');
    const progressBar = slider.querySelector('.options-hero-slider__progress-bar');

    const swiper = new Swiper(swiperElement, {
      effect,

      speed,

      loop,

      slidesPerView: 1,

      watchOverflow: true,

      preloadImages: false,

      lazy: {
        loadPrevNext: true
      },

      keyboard: {
        enabled: true
      },

      grabCursor: true,

      observer: true,

      observeParents: true,

      navigation:
        nextButton && prevButton
          ? {
              nextEl: nextButton,
              prevEl: prevButton
            }
          : false,

      pagination: pagination
        ? {
            el: pagination,
            clickable: true
          }
        : false,

      autoplay: autoplayEnabled
        ? {
            delay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }
        : false,

      fadeEffect:
        effect === 'fade'
          ? {
              crossFade: true
            }
          : undefined,

      on: {
        init() {
          resetProgress();
          startProgress();
        },

        slideChangeTransitionStart() {
          resetProgress();
        },

        slideChangeTransitionEnd() {
          startProgress();
        }
      }
    });

    function resetProgress() {
      if (!progressBar) return;

      progressBar.style.transition = 'none';
      progressBar.style.width = '0%';

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          startProgress();
        });
      });
    }

    function startProgress() {
      if (!progressBar) return;

      if (!autoplayEnabled) return;

      progressBar.style.transition = `width ${delay}ms linear`;
      progressBar.style.width = '100%';
    }

    slider.addEventListener('mouseenter', () => {
      if (!swiper.autoplay) return;

      swiper.autoplay.stop();
    });

    slider.addEventListener('mouseleave', () => {
      if (!swiper.autoplay) return;

      swiper.autoplay.start();
    });

    instances.set(section.id, swiper);
  }

  function initAll() {
    document
      .querySelectorAll('.section-options-hero-slider')
      .forEach(initHeroSlider);
  }

  document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', (event) => {
    initHeroSlider(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const id = event.target.id;

    if (!instances.has(id)) return;

    instances.get(id).destroy(true, true);
    instances.delete(id);
  });

  document.addEventListener('shopify:block:select', (event) => {
    const section = event.target.closest('.section-options-hero-slider');

    if (!section) return;

    const swiper = instances.get(section.id);

    if (!swiper) return;

    const slide = event.target.closest('.swiper-slide');

    if (!slide) return;

    swiper.slideToLoop(slide.dataset.swiperSlideIndex || slide.swiperSlideIndex);
  });
})();